(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion"] && !Shopify.designMode) return;
  try {
    
  class AccordionComponent extends HTMLElement {
    connectedCallback() {
      this.rows = this.querySelectorAll('.accordion-row')
      this.activeRow = null

      this.rows.forEach(row => {
        const trigger = row.querySelector('.accordion-trigger')
        const contentWrapper = row.querySelector('.accordion-content-wrapper')
        const content = row.querySelector('.accordion-content')

        contentWrapper.style.height = '0px'

        trigger.addEventListener('click', () => {
          const isOpen = trigger.getAttribute('aria-expanded') === 'true'

          if (isOpen) {
            this.closeRow(row)
          } else {
            // close open rows first
            if (this.activeRow && this.activeRow !== row) {
              this.closeRow(this.activeRow)
            }
            this.openRow(row)
            this.activeRow = row
          }
        })
      })
    }

    openRow(row) {
      const trigger = row.querySelector('.accordion-trigger')
      const contentWrapper = row.querySelector('.accordion-content-wrapper')
      const content = row.querySelector('.accordion-content')

      row.classList.add('is-opening')
      trigger.setAttribute('aria-expanded', 'true')
      contentWrapper.setAttribute('aria-hidden', 'false')

      const height = content.scrollHeight

      contentWrapper.style.height = height + 'px'

      const handleTransitionEnd = () => {
        row.classList.remove('is-opening')
        row.classList.add('is-open')
        contentWrapper.style.height = 'auto'
        contentWrapper.removeEventListener('transitionend', handleTransitionEnd)
      }

      contentWrapper.addEventListener('transitionend', handleTransitionEnd)
    }

    closeRow(row) {
      const trigger = row.querySelector('.accordion-trigger')
      const contentWrapper = row.querySelector('.accordion-content-wrapper')
      const content = row.querySelector('.accordion-content')

      row.classList.add('is-closing')
      row.classList.remove('is-open')

      const height = content.scrollHeight
      contentWrapper.style.height = height + 'px'

      contentWrapper.offsetHeight

      contentWrapper.style.height = '0px'
      trigger.setAttribute('aria-expanded', 'false')
      contentWrapper.setAttribute('aria-hidden', 'true')

      const handleTransitionEnd = () => {
        row.classList.remove('is-closing')
        contentWrapper.removeEventListener('transitionend', handleTransitionEnd)

        if (this.activeRow === row) {
          this.activeRow = null
        }
      }

      contentWrapper.addEventListener('transitionend', handleTransitionEnd)
    }
  }

  customElements.define('accordion-component', AccordionComponent)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderComponent extends window.HTMLElement {
    connectedCallback() {
      this.header = this.querySelector('.header-wrap')
      this.hamburgerBtn = this.querySelector('.hamburger-button')

      if (this.hamburgerBtn) {
        this.hamburgerBtn.addEventListener('click', this.toggleMenu.bind(this))
      }

      this.initColorObserver()
    }

    initColorObserver() {
      this.intersectingSections = new Set()

      this.lightSections = document.querySelectorAll(
        '.scheme.off-white, .scheme.chartreuse'
      )

      if (this.lightSections.length === 0) {
        return
      }

      const viewportHeight = window.innerHeight
      const headerHeight = this.header.offsetHeight || 80 // Fallback to 80px
      const bottomMargin = -(viewportHeight - headerHeight)

      this.lastViewportHeight = viewportHeight

      this.observer = new IntersectionObserver(
        entries => this.handleIntersection(entries),
        {
          rootMargin: `0px 0px ${bottomMargin}px 0px`,
          threshold: [0, 0.1, 0.9, 1],
        }
      )

      this.lightSections.forEach(section => {
        this.observer.observe(section)
      })

      // debounced resize handler
      if (!this.handleResize) {
        let resizeTimeout
        this.handleResize = () => {
          clearTimeout(resizeTimeout)
          resizeTimeout = setTimeout(() => {
            const newViewportHeight = window.innerHeight
            if (Math.abs(newViewportHeight - this.lastViewportHeight) > 10) {
              if (this.observer) {
                this.observer.disconnect()
              }
              this.initColorObserver()
            }
          }, 150)
        }

        window.addEventListener('resize', this.handleResize)
      }
    }

    handleIntersection(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.intersectingSections.add(entry.target)
        } else {
          this.intersectingSections.delete(entry.target)
        }
      })

      this.updateHeaderClass()
    }

    updateHeaderClass() {
      if (this.intersectingSections.size > 0) {
        this.header.classList.add('header-dark')
      } else {
        this.header.classList.remove('header-dark')
      }
    }

    toggleMenu(e) {
      e.preventDefault()
      const isOpen = this.header.classList.toggle('is-menu-open')

      // Toggle hamburger animation
      this.hamburgerBtn.classList.toggle('is-open', isOpen)

      // Update aria-expanded for accessibility
      this.hamburgerBtn.setAttribute('aria-expanded', isOpen)

      // Toggle body scroll
      document.body.style.overflow = isOpen ? 'hidden' : ''
    }
  }

  window.customElements.define('header-component', HeaderComponent)

  } catch(e) { console.error(e); }
})();
})();
